'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WinresEventTickets]');

var WinresEventTickets = function () {
    function WinresEventTickets($scope, scheduleService, $uibModal, $element) {
        _classCallCheck(this, WinresEventTickets);

        this.$scope = $scope;
        this.scheduleService = scheduleService;
        this.$uibModal = $uibModal;
        this.$element = $element;
    }

    _createClass(WinresEventTickets, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.state = 'error';
            this.error = 'left_in_initial_state';

            this.weeks = [];

            this.$scope.$watch(function () {
                return _this.destCode;
            }, function () {
                return _this.update();
            });

            this.data = this.winresReservationContext.getContext();
        }
    }, {
        key: 'update',
        value: function update() {
            log('Update:', this.destCode);

            if (this.destCode) {
                this.load(this.destCode);
            } else {
                this.state = 'error';
                this.error = 'no_dest_code';
                return;
            }
        }
    }, {
        key: 'load',
        value: function load(destCode) {
            var _this2 = this;

            this.state = 'loading';

            this.scheduleService.getTickets(destCode).then(function (response) {
                if (response && response.result == 'OK') {
                    return response.items;
                } else {
                    log.error('Invalid response:', response);
                    throw new Error('Invalid response');
                }
            }).then(function (days) {
                log('Days:', days);
                _this2.render(days);
                _this2.state = 'ready';
                _this2.error = null;
            }).catch(function (error) {
                log.error('Error:', error);
                _this2.state = 'error';
                _this2.error = 'load_failed';
            });
        }
    }, {
        key: 'getTicketInfo',
        value: function getTicketInfo(item) {
            this.scheduleService.getTicketInfo(item.destcode, item.prodcode).then(function (response) {
                item.questions = response.ExtraQuestions;
            }).catch(function (error) {
                log.error('Error:', error);
            });
        }
    }, {
        key: 'render',
        value: function render(days) {
            if (days.length % 7 !== 0) {
                throw new Error('The list of days should contain full weeks.');
            }

            _.each(days, function (day) {
                _.each(day.items, function (item) {
                    item.max = item.available > 4 ? 4 : item.available;

                    var amounts = _.range(item.max + 1);

                    // [1, 2, 3, 4]
                    amounts.shift();

                    item.amounts = amounts;
                });
            });

            var weeks = _.chunk(days, 7);

            this.weeks = _.map(weeks, function (weekDays) {
                return {
                    days: _.map(weekDays, function (day) {
                        var items = _.map(day.items, function (item) {
                            return _.assign({}, item, { time: null });
                        });
                        return _.assign({}, day, { items: items });
                    })
                };
            });
        }
    }, {
        key: 'addToCart',
        value: function addToCart(day, item, amount) {
            var product = {
                DestinationInfo: {
                    DestinationCode: item.destcode,
                    DestinationName: item.name,
                    ProductCode: item.prodcode,
                    ProductName: item.title
                },
                BeginDate: day.date,
                EndDate: day.date,
                //EndDate: moment(day.date).add(1, 'days').format('YYYY-MM-DD'),
                ReservablePrices: item.prices,
                ExtraQuestions: item.questions,

                // Internal use
                Price: 0
            };

            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);

            productLine.Amount += amount;

            if (!_.isArrayLike(item.prices) || item.prices.length === 0) {
                throw new Error("Item has no prices.");
            }

            var priceIndex = item.prices[0].Index;

            var priceSelection = this.winresReservationContext.findOrCreatePriceSelection(priceIndex, productLine);
            priceSelection.Amount += amount;

            this.winresReservationContext.calculateTotalPrice(productLine);

            // item.productLine = productLine;
        }
    }, {
        key: 'getProductLine',
        value: function getProductLine(day, item) {
            var product = {
                DestinationInfo: {
                    DestinationCode: item.destcode,
                    ProductCode: item.prodcode
                },
                BeginDate: day.date,
                EndDate: day.date
            };

            return this.winresReservationContext.findProductLineByProduct(product);;
        }
    }, {
        key: 'openModal',
        value: function openModal(_day, _item) {
            var _this3 = this;

            log("Open modal:", _day, _item);
            var modalInstance = this.$uibModal.open({
                component: 'winresEventTicketModal',
                size: 'lg',
                appendTo: this.$element,
                backdrop: true,
                backdropClass: 'transparent-modal-backdrop',
                windowClass: 'event-ticket-modal',
                resolve: {
                    day: function day() {
                        return _day;
                    },
                    item: function item() {
                        return _item;
                    },
                    productLine: function productLine() {
                        return _this3.getProductLine(_day, _item);
                    }
                }
            });

            this.getTicketInfo(_item);

            // Close modal
            modalInstance.result.then(function (amount) {
                log("Amount:", amount);
                _this3.addToCart(_day, _item, amount);
            }, function (cancel) {
                log("Modal closed.");
            });
        }
    }]);

    return WinresEventTickets;
}();

WinresEventTickets.$inject = ['$scope', 'scheduleService', '$uibModal', '$element'];

_module3.default.component('winresEventTickets', {
    template: require('./winresEventTickets.html'),
    controller: WinresEventTickets,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        destCode: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresEventTickets/winresEventTickets.js
// module id = 301
// module chunks = 2